// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"9809e382","251":"52874194","348":"1632d603","364":"1cac55a6","571":"96fd0add"}[chunkId] + ".chunk.js";
};